module.exports = __webpack_public_path__ + "img/star-1.9f88cd32.svg";